export { default as Title } from './title';
export { default as Subtitle } from './subtitle';
export { default as InformationSection } from './informationSection';
export { default as PhotosSection } from './photosSection';
export { default as EmployeeComponent } from './employeeComponent';
export { default as OfficeFlats } from './officeFlats';
